<template>
  <div
    :class="{
      content: true,
      page: page.total > queryParams.Limit,
    }"
    ref="content"
  >
    <div class="main-content">
      <div class="search-box" ref="search">
        <a-form>
          <a-row>
            <a-col :sm="6" :xxl="4">
              <e-date-time
                title="开始时间"
                :labelCol="8"
                :valueCol="14"
                v-model:value="queryParams.BeginDate"
              />
            </a-col>
            <a-col :sm="6" :xxl="4">
              <e-date-time
                title="结束时间"
                :labelCol="8"
                :valueCol="14"
                v-model:value="queryParams.EndDate"
              />
            </a-col>
            <a-col :sm="5" :xxl="4">
              <e-radio
                title="类型"
                :labelCol="6"
                :valueCol="16"
                v-model:value="queryParams.Type"
                :options="[
                  { label: '日报', value: 0 },
                  { label: '月报', value: 1 },
                ]"
              />
            </a-col>
            <a-col>
              <a-button type="primary" @click="getDataList(1)"> 查询 </a-button>
              <a-button
                type="primary"
                @click="reset(() => resetFun())"
                danger
                style="margin-left: 10px"
              >
                重置
              </a-button>
              <a-button
                type="primary"
                @click="exportExcel"
                style="margin-left: 10px"
              >
                导出Excel
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="data-list">
        <a-table
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :loading="loading"
          :row-key="(record) => record.id"
          :scroll="{ y: height, x: width }"
        >
          <template #bodyCell="{ column, record, index }">
            <template v-if="column.key === 'index'">
              {{ (page.page - 1) * queryParams.Limit + index + 1 }}
            </template>

            <template v-if="column.key === 'peopleCount'">
              {{ record.peopleSuccessCount }}
              /
              <span style="color: #f50">{{record.peopleErrCount}}</span>
            </template>

            <template v-if="column.key === 'walletPayAmount'">
              ¥{{ record.walletPayAmount }}
            </template>

            <template v-if="column.key === 'cashPayAmount'">
              ¥{{ record.cashPayAmount }}
            </template>

            <template v-if="column.key === 'totalPayAmount'">
              ¥{{ record.totalPayAmount }}
            </template>
          </template>
        </a-table>
      </div>
    </div>

    <div class="pagination">
      <a-pagination
        :total="page.total"
        v-model:current="page.page"
        v-model:page-size="queryParams.Limit"
        :hide-on-single-page="true"
        :show-size-changer="true"
        :page-size-options="['20', '40', '100', '200']"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
      >
        <template #itemRender="{ page, type }">
          <a v-if="type === 'prev'" class="ant-pagination-item-link">上一页</a>
          <a v-else-if="type === 'next'" class="ant-pagination-item-link">
            下一页
          </a>
          <span v-else>{{ page }}</span>
        </template>
      </a-pagination>
      <span>数据总数：{{ page.total }}</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import {} from '@ant-design/icons-vue'
import { OrderClass } from '@/apis/order'
import page from '@/mixins/page'
import dayjs from 'dayjs'
import fileDownload from 'js-file-download'

const api = new OrderClass()
export default defineComponent({
  mixins: [page],
  components: {},
  setup () {
    const loading = ref(false)
    const height = ref(500)
    const width = ref(500)

    const queryParams = ref({
      Limit: 50
    })
    const columns = [
      {
        title: '日期',
        key: 'date',
        dataIndex: 'date',
        width: 180
      },
      {
        title: '订单数量',
        key: 'orderCount',
        dataIndex: 'orderCount',
        width: 100
      },
      {
        title: '成交数量',
        key: 'successCount',
        dataIndex: 'successCount',
        width: 100
      },
      {
        title: '异常数量',
        key: 'errCount',
        dataIndex: 'errCount',
        width: 100
      },
      {
        title: '订单总人数',
        key: 'peopleCount',
        dataIndex: 'peopleCount',
        width: 120
      },
      {
        title: '人均消费',
        key: 'peopleAvgPayAmount',
        dataIndex: 'peopleAvgPayAmount',
        width: 100
      },
      {
        title: '桌均消费',
        key: 'tableAvgPayAmount',
        dataIndex: 'tableAvgPayAmount',
        width: 100
      },
      {
        title: '订单总额',
        key: 'totalAmount',
        dataIndex: 'totalAmount',
        width: 100
      },
      {
        title: '实付金额',
        key: 'totalPayAmount',
        dataIndex: 'totalPayAmount',
        width: 100
      },
      {
        title: '前厅金额',
        key: 'qiantingAmount',
        dataIndex: 'qiantingAmount',
        width: 100
      },
      {
        title: '厨房金额',
        key: 'chufangAmount',
        dataIndex: 'chufangAmount',
        width: 100
      },
      {
        title: '全民付',
        key: 'uninPayAmount',
        dataIndex: 'uninPayAmount',
        width: 100
      },
      {
        title: '微信',
        key: 'wechatPayAmount',
        dataIndex: 'wechatPayAmount',
        width: 100
      },
      {
        title: '支付宝',
        key: 'alipayAmount',
        dataIndex: 'alipayAmount',
        width: 100
      },
      {
        title: '刷卡支付',
        key: 'bankcardPayAmount',
        dataIndex: 'bankcardPayAmount',
        width: 100
      },
      {
        title: '现金支付',
        key: 'cashPayAmount',
        dataIndex: 'cashPayAmount',
        width: 100
      },
      {
        title: '会员支付',
        key: 'walletPayAmount',
        dataIndex: 'walletPayAmount',
        width: 100
      },
      {
        title: '挂账金额',
        key: 'creditPayAmount',
        dataIndex: 'creditPayAmount',
        width: 100
      },
      {
        title: '齐商银行',
        key: 'qishangPayAmount',
        dataIndex: 'qishangPayAmount',
        width: 100
      }
    ]
    return {
      columns,
      loading,
      height,
      width,
      queryParams
    }
  },
  created () {
    this.getDataList(1)
  },
  methods: {
    getDataList (page) {
      this.loading = true
      this.page.page = page
      const q = { ...this.queryParams }
      q.Offset = (page - 1) * q.Limit

      if (q.BeginDate) {
        q.BeginDate = q.BeginDate.format('YYYY-MM-DD')
      }
      if (q.EndDate) {
        q.EndDate = q.EndDate.format('YYYY-MM-DD')
      }

      api.orderMoney(q).then((resp) => {
        this.list = resp.data
        this.page.total = resp.total
        this.loading = false
        this.getTableHeight()
      })
    },
    resetFun () {
      this.queryParams = {
        Limit: 50
      }

      this.getDataList(1)
    },

    getTableHeight () {
      const paddingBottom = this.page.total > this.queryParams.Limit ? 50 : 9
      const mainPadding = 30
      const thead = 56
      this.height =
        this.$refs.content.offsetHeight -
        this.$refs.search.offsetHeight -
        thead -
        paddingBottom -
        mainPadding

      this.width = this.$refs.search.offsetWidth - 10
    },

    exportExcel () {
      const q = { ...this.queryParams }

      if (q.BeginDate) {
        q.BeginDate = q.BeginDate.format('YYYY-MM-DD')
      }
      if (q.EndDate) {
        q.EndDate = q.EndDate.format('YYYY-MM-DD')
      }

      api.exportOrderMoney(q).then((resp) => {
        fileDownload(
          resp,
          '订单资金统计' + dayjs().format('YYYYMMDDHHmmss') + '.xlsx'
        )
      })
    }
  }
})
</script>

<style lang="less" scoped></style>
